import { render, staticRenderFns } from "./Jurnal.vue?vue&type=template&id=35bb0b1c&scoped=true"
import script from "./Jurnal.vue?vue&type=script&lang=js"
export * from "./Jurnal.vue?vue&type=script&lang=js"
import style0 from "./Jurnal.vue?vue&type=style&index=0&id=35bb0b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb0b1c",
  null
  
)

export default component.exports